
import { defineComponent, reactive, computed } from "vue";
import Register from "../../../_models/Register";
import ResponseData from "../../../_models/ResponseData";
import XarcadeAccountService from "../../../services/XarcadeAccountService";
import { Helper } from "@/utils/Helper";
// form validators
import useValidate from "@vuelidate/core";
import authFooter from "@/modules/auth/components/authFooterComponent.vue"
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs,
} from "@vuelidate/validators";

export default defineComponent({
  name: "viewAuthSignupSuccess",
  components:{
    authFooter
  },

  setup() {
    const state = reactive({
      firstName: "",
      lastName: "",
      userName: "",
      email: "",
      password: {
        password: "",
        confirmPassword: "",
      },
      companyName: "",
      acceptTerms: true,
    });

    const rules = computed(() => {
      return {
        firstName: { required },
        lastName: { required },
        userName: { required },
        email: { required, email },
        password: {
          password: { required, minLength: minLength(8) },
          confirmPassword: {
            required,
            sameAs: sameAs(state.password.password),
          },
        },
        companyName: { required, minLength: maxLength(100) },
        acceptTerms: { required },
      };
    });

    const v$ = useValidate(rules, state);

    return {
      state,
      v$,
      activeSection: "registerUser",
      companyName: "",
      errorSection: false,
      errorMessage: "",
    };
  },

  methods: {
    submitForm() {
      this.v$.$validate();
      if (!this.v$.$error) {
        this.activeSection = "loadingRegisterUser";
        let data = {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          userName: this.state.userName,
          password: this.state.password.password,
          confirmPassword: this.state.password.confirmPassword,
          acceptTerms: this.state.acceptTerms,
        };

        XarcadeAccountService.registerUser(data)
          .then((response: ResponseData) => {
            if (response.data["success"]) {
              this.activeSection = "";
              this.activeSection = "registerUserSuccess";
              Helper.toastSuccessHandling(response.data['message']);
            }
          })
          .catch((error) => {
            this.errorSection = true;
            this.errorMessage = Helper.endpointErrorHandling(error);
          });
      } else {
        console.log("invalid form");
      }
    },
  },
});
